import { EventEmitter, Input, Output, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
	selector: 'media-preview',
	standalone: false
})
export class MediaPreviewDirective extends UpgradeComponent {
	@Input() public previewerId;
	@Input() public media;
	@Input() public initialOffset;
	@Output() public onSeek: EventEmitter<any>;
	@Input() public options;
	@Output() public onInit: EventEmitter<any>;
	@Output() public onInitError: EventEmitter<any>;
	@Input() public collapseAudio;
	@Input() public minimizedControls;
	@Input() public allowDownload;

	constructor (
		elementRef: ElementRef,
		injector: Injector
	) {
		super('mediaPreview', elementRef, injector);
		const $scope = injector.get('$scope');
		/**
		 * We have to fire the evalAsync otherwise it won't fire the ng1 digest cycle
		 * https://stackoverflow.com/q/58986644/1248889
		 */
		$scope.$evalAsync();
	}
}
